import { Theme } from '@material-ui/core/styles';

export const getMuiTooltip = (theme: Theme): Record<string, unknown> => ({
  MuiTooltip: {
    arrow: {
      color: theme.palette.common.white,
    },
    tooltip: {
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: `0px 1px 3px ${theme.palette.grey[500]}`,
      color: theme.palette.common.black,

      '& ::before': {
        boxShadow: `0px 0px 2px ${theme.palette.grey[500]}`,
      },
    },
  },
});
